import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class RoleGuard implements CanActivate {


  constructor(private _authService: AuthService, private _router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
   

    // const user = this._authService.decode();


     localStorage.setItem('state',state.url);

     localStorage.setItem('qr',JSON.stringify(next.queryParams));

   

	  const token =(localStorage.getItem('token') !=undefined)? atob(localStorage.getItem('token')):''; 
    
    

    if(token!=''){
     

      this._authService.isAuthenticated().subscribe(e => {
       
       
              
        if(e.status=='error' || e.status==false){

         // localStorage.clear();
   
        this._router.navigate(['/login']);

        return false;

        } else{

          
          next.data.role.forEach(element => {

          // console.log(element);

          // console.log(e.permission.indexOf(element));


          
          if(e.permission!=undefined && e.permission.indexOf(element) == -1 && element !=''){

         
            //localStorage.clear(); 

            this._router.navigate(['/login']);


          }

           
         });


        }  
       
             
         

       }); 

       return true;

    }  
     
    // if (user.role === next.data.role) {
    //   return true;
    // }

    // navigate to not found page
    this._router.navigate(['/login']);

    return false;
  }

}
